import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import axios from "axios";
import { BACKEND_URL } from "../lib/api";

/**
 * Small "Last updated" pill rendered at the top of Privacy / Terms / Support.
 * Fetches `/api/public/page-versions` once on mount and reads the stamp for
 * the given `pageKey`. Quietly hides itself if the API is unreachable or the
 * key is missing — never blocks the page render.
 */
export default function LastUpdatedBadge({ pageKey }) {
  const [stamp, setStamp] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${BACKEND_URL}/api/public/page-versions`, { timeout: 5000 })
      .then((r) => {
        if (cancelled) return;
        const v = r.data?.[pageKey];
        if (v?.updated_at) setStamp(v.updated_at);
      })
      .catch(() => { /* silent — badge is purely informational */ });
    return () => { cancelled = true; };
  }, [pageKey]);

  if (!stamp) return null;

  const date = new Date(stamp);
  const human = date.toLocaleDateString("en-GB", {
    day: "numeric", month: "short", year: "numeric",
  });

  return (
    <span
      data-testid={`last-updated-${pageKey}`}
      title={date.toLocaleString()}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#114232]/6 border border-[#114232]/15 text-[11px] uppercase tracking-[0.16em] font-bold text-[#114232]"
    >
      <Clock className="w-3 h-3 text-[#c15337]" />
      Last updated {human}
    </span>
  );
}
